import { LIMPAR_FILTRO_DATA_REJEITADA } from './types';

export default function limparFiltroDatasRejeitadas (filtro) {
  return {
    type: LIMPAR_FILTRO_DATA_REJEITADA,
    payload: filtro
  }
}
